import { z } from 'zod';

import {
  emailSchema,
  isoDateSchema,
  isoTimestampSchema,
  uuidSchema,
} from './primitives.js';

export const reportStatusSchema = z.enum([
  'draft',
  'review',
  'approved',
  'sent',
]);

export const reportSchema = z.object({
  id: uuidSchema,
  contractId: uuidSchema,
  periodStartDate: isoDateSchema,
  periodEndDate: isoDateSchema,
  status: reportStatusSchema,
  pdfR2Key: z.string().nullable(),
  htmlRendered: z.string().nullable(),
  generatedAt: isoTimestampSchema,
  reviewedByUserId: uuidSchema.nullable(),
  sentAt: isoTimestampSchema.nullable(),
  sentToEmails: z.array(emailSchema),
});

export const reportApproveInputSchema = z.object({
  toEmails: z.array(emailSchema).min(1),
  ccEmails: z.array(emailSchema).default([]),
});
